import { Select } from '@/components/ui/select'
import { useTranslations } from 'next-intl'

type Props = {
  onFilterChange?: (value: string) => void
  currentPage: number
  totalItems: number
  itemsPerPage: number
}

export const ReviewsHeaderList = ({
  onFilterChange,
  currentPage,
  totalItems,
  itemsPerPage,
}: Props) => {
  const startItem = (currentPage - 1) * itemsPerPage + 1
  const endItem = Math.min(currentPage * itemsPerPage, totalItems)
  const t = useTranslations('product_detail.title')

  const sortOptions = [
    {
      value: 'star_order_by:desc',
      label: (
        <span>
          {t('rating')}: {t('rating_desc')}
        </span>
      ),
    },
    {
      value: 'star_order_by:asc',
      label: (
        <span>
          {t('rating')}: {t('rating_asc')}
        </span>
      ),
    },
  ]

  return (
    <div className='mb-2 flex items-center justify-between'>
      <p className='font-sans text-sm leading-4.5 text-neutral-500'>
        {t('display_reviews')}{' '}
        <b>
          {startItem}-{endItem}
        </b>
      </p>
      <Select
        placeholder={t('sort_by')}
        className={{
          trigger:
            'w-fit data-[placeholder]:font-normal data-[placeholder]:text-neutral-500',
        }}
        options={sortOptions}
        onValueChange={(value) => onFilterChange?.(value)}
        aria-label={t('sort_by')}
      />
    </div>
  )
}
